<template>
	<div v-if="reportList.length" class="esg-report">
		<p class="est-title">{{ $t('enterprise.esg-report') }}</p>
		<div class="report-container">
			<div class="report-wrapper" v-for="(report, index) in reportList" :key="index" @click="gotoReport(report)">
				<div v-if="report.logoUrl || report.hasCover" class="report-cover">
					<img class="cover-img" :src="report.logoUrl || coverList[report.fileUrl]" alt="" />
					<div class="cover-mask"></div>
				</div>
				<div v-else class="report-cover default-cover">
					<p class="cover-title">
						<span class="text-overflow2">
							{{ report.subject }}
						</span>
					</p>
				</div>
				<p class="text-overflow report-title">{{ report.subject }}</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { getPDFCover } from '@/utils/api';
import { useModuleNavigation } from '@/rebuild/hooks/useModuleNavigation';

const props = defineProps({
	reportList: {
		type: Array,
		default: () => []
	}
});

const coverList = ref({});

// 监听报告列表变化，处理PDF封面
watch(
	() => props.reportList,
	newList => {
		if (!newList?.length) return;

		newList.forEach(ele => {
			if (!ele.logoUrl && ele.fileUrl && ele.fileUrl.match(/pdf$/i) && ele.hasCover) {
				getPDFCover(ele.fileUrl).then(cover => {
					coverList.value = Object.assign({}, coverList.value, {
						[ele.fileUrl]: cover
					});
				});
			}
		});
	},
	{ immediate: true }
);

const { viewModule } = useModuleNavigation();
function gotoReport(report) {
	viewModule('esg', report);
}
</script>

<style lang="less" scoped>
.esg-report {
	margin-top: 16px;

	.est-title {
		margin: 8px 0;
		color: var(--t-emphasis-color, #1d2129);
		font-size: 18px;
		font-weight: 600;
		line-height: normal;
	}

	.report-container {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 12px;

		.report-wrapper {
			min-width: 0;
			border-radius: 2px;
			background: #f2f3f5;
			overflow: hidden;
		}
		.report-cover {
			position: relative;
			width: 100%;
			padding-top: 60%;
		}
		.cover-img {
			position: absolute;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: #fff;
			object-fit: cover;
		}
		.cover-mask {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.03);
		}
		.default-cover {
			background: url(https://image.comein.cn/web/irm/irstore/report-default-cover.png);
			background-size: cover;

			display: flex;
			align-items: center;

			.cover-title {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				width: 100%;
				padding: 6px 16px;
				background: rgba(255, 255, 255, 0.4);
				backdrop-filter: blur(5px);

				color: #2e570c;
				text-align: center;
				font-size: 16px;
				font-weight: 500;
				line-height: 18px;
			}
		}
		.report-title {
			padding: 0 8px;

			color: #1d2129;
			font-size: 12px;
			font-weight: 500;
			line-height: 24px;
		}
	}
}
</style>
